import Vue from 'vue'
import configs from '@/config'

let resource = null

const actions = {
  paypalCreateOrder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/paypal-create-order/`,
  },
  paypalCaptureOrder: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/paypal-capture-order/`,
  },
  getOfferOnCancellation: {
    method: 'POST',
    url: `${configs.baseUrl}/api/pricing/auto-offer-on-cancel/`,
  },
}

const initResource = () => {
  resource = Vue.resource('', {}, actions)
}

const paypalCreateOrder = (payload) => {
  return resource.paypalCreateOrder(payload)
}

const paypalCaptureOrder = (payload) => {
  return resource.paypalCaptureOrder(payload)
}

const getOfferOnCancellation = () => {
  return resource.getOfferOnCancellation()
}

export default {
  initResource,
  paypalCreateOrder,
  paypalCaptureOrder,
  getOfferOnCancellation,
}
